<template>
    <div class="animated fadeIn">
        <b-container class="w-100 px-0">
            <b-row class="m-0 py-2 px-2 w-100">
                <b-form @submit.prevent="store" enctype="multipart/form-data" class="w-100">
                    <b-row class="bg-light m-0 pt-1 pb-4">
                        <b-col lg="8" offset-lg="2" md="12">
                            <!-- ////////////////////// NIF ////////////////////// !-->
                            <b-form-group
                                label="<strong>NIF *</strong>"
                                label-for="nif"
                                label-cols="4"
                                :horizontal="true"
                                class="w-100 text-right mt-3 mb-0">
                                <b-form-input
                                    id="nif"
                                    name="nif"
                                    type="text"
                                    placeholder="NIF"
                                    v-model="entity.nif"
                                    class="w-100"
                                    v-validate="{ required: true, regex: /^[a-zA-Z0-9-_]+$/ }"
                                    :state="validateState('nif')"
                                    aria-describedby="check_nif">
                                </b-form-input>
                            </b-form-group>
                            <div class="text-danger text-right" id="check_nif">
                                <small>{{ errors.first('nif') }}</small>
                            </div>
                            <!-- !-->
                            <!-- ////////////////////// Nombre ////////////////////// !-->
                            <b-form-group
                                label="<strong>Nombre *</strong>"
                                label-for="name"
                                label-cols="4"
                                :horizontal="true"
                                class="w-100 text-right mt-3 mb-0">
                                <b-form-input
                                    id="name"
                                    name="name"
                                    type="text"
                                    placeholder="Nombre"
                                    v-model="entity.name"
                                    class="w-100"
                                    v-validate="'required|min:3'"
                                    :state="validateState('name')"
                                    aria-describedby="check_name"></b-form-input>
                            </b-form-group>
                            <div class="text-danger text-right" id="check_name">
                                <small>{{ errors.first('name') }}</small>
                            </div>
                            <!-- !-->
                            <!-- ////////////////////// Apellidos ////////////////////// !-->
                            <b-form-group
                                label="<strong>Apellidos *</strong>"
                                label-for="surname"
                                label-cols="4"
                                :horizontal="true"
                                class="w-100 text-right mt-3 mb-0">
                                <b-form-input
                                    id="surname"
                                    name="surname"
                                    type="text"
                                    placeholder="Apellidos"
                                    v-model="entity.surname"
                                    class="w-100"
                                    v-validate="'required|min:3'"
                                    :state="validateState('surname')"
                                    aria-describedby="check_surname"></b-form-input>
                            </b-form-group>
                            <div class="text-danger text-right" id="check_surname">
                                <small>{{ errors.first('surname') }}</small>
                            </div>
                            <!-- !-->
                            <!-- ////////////////////// Sexo ////////////////////// !-->
                            <b-form-group
                                label="<strong>Sexo *</strong>"
                                label-for="sex"
                                label-cols="4"
                                :horizontal="true"
                                class="w-100 text-right mt-3 mb-0">
                                <multiselect
                                    name="sex"
                                    v-model="entity.sex"
                                    :options="sex.map(type => type.uuid)"
                                    :custom-label="opt => sex.find(x => x.uuid == opt).name"
                                    :multiple="false"
                                    :allowEmpty="false"
                                    placeholder="Seleccione"
                                    selectLabel="+"
                                    deselectLabel="-"
                                    v-if="sex">
                                </multiselect>
                            </b-form-group>
                            <!-- ////////////////////// Fecha de Nacimiento ////////////////////// !-->
                            <b-form-group
                                label="<strong>F. de Nacimiento</strong>"
                                label-for="partnerBirthdate"
                                label-cols="4"
                                :horizontal="true"
                                class="w-100 text-right mt-3 mb-0">
                                <v-date-picker v-model="entityBirthdayFormatted" :max-date="new Date()" popoverDirection="top">
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <b-form-input
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            @change="changeBirthday"
                                            id="partnerBirthdate"
                                            name="partnerBirthdate"
                                            class="w-100"
                                            v-validate="'partnerBirthdate'"
                                            :state="validateState('partnerBirthdate')"
                                            aria-describedby="check_partnerBirthdate" />
                                    </template>
                                </v-date-picker>
                            </b-form-group>
                            <div class="text-danger text-right" id="check_partnerBirthdate">
                                <small>{{ errors.first('partnerBirthdate') }}</small>
                            </div>
                            <!-- !-->

                            <!-- ////////////////////// Registro de Autónomo ////////////////////// !-->
                            <b-form-group
                                label="<strong>Alta Autónomo</strong>"
                                label-for="autonomousRegisteredAt"
                                label-cols="4"
                                :horizontal="true"
                                class="w-100 text-right mt-3 mb-0">
                                <v-date-picker v-model='entityAutonomousRegisteredAtFormatted' :max-date="new Date()" popoverDirection="top">
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <b-form-input
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            @change="changeAutonomousRegistered"
                                            id="autonomousRegisteredAt"
                                            name="autonomousRegisteredAt"
                                            class="w-100"
                                            v-validate="{required: false, autonomousRegisteredAt: {birthday: entity.birthday}}"
                                            :state="validateState('autonomousRegisteredAt')"
                                            aria-describedby="check_autonomousRegisteredAt" />
                                    </template>
                                </v-date-picker>
                            </b-form-group>
                            <div class="text-danger text-right" id="check_autonomousRegisteredAt">
                                <small>{{ errors.first('autonomousRegisteredAt') }}</small>
                            </div>
                            <!-- !-->

                            <!-- ////////////////////// Sede ////////////////////// !-->
                            <b-form-group
                                label="<strong>Sede *</strong>"
                                label-for="headquartersId"
                                label-cols="4"
                                :horizontal="true"
                                class="w-100 text-right mt-3 mb-0">
                                <multiselect
                                    name="headquartersId"
                                    v-model="entity.headquartersId"
                                    :options="headquarters.map(type => type.uuid)"
                                    :custom-label="opt => headquarters.find(x => x.uuid == opt).name"
                                    :multiple="false"
                                    :allowEmpty="false"
                                    placeholder="Seleccione"
                                    selectLabel="+"
                                    deselectLabel="-"
                                    v-if="headquarters.length > 0">
                                </multiselect>
                            </b-form-group>
                            <!-- !-->

                        </b-col>
                    </b-row>
                    <b-row class="pt-4 m-0 pb-0">
                        <div class="px-0 col float-left">
                            <button
                                v-if="mixinCheckPermission('EDIT_MEMBER_BASIC_DATA')"
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg pull-right"
                                :disabled="!validate()">Guardar
                            </button>
                        </div>
                    </b-row>
                </b-form>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import {request} from '@/helpers/services';
    import Multiselect from 'vue-multiselect';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import moment from 'moment';

    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: 'editPartners1',
        components: {
            'v-date-picker': DatePicker,
            Multiselect
        },
        props: ['partner','headquarters'],
        data: function () {
            return {
                entity_url: '/members/steps/1',
                entity: {
                    nif: "",
                    name: "",
                    surname: "",
                    birthday: null,
                    autonomousRegisteredAt: null,
                    sex: 1,
                    headquartersId: "",
                    memberId: null,
                },
                sex: [
                    {uuid: 1, name: 'Hombre'},
                    {uuid: 2, name: 'Mujer'},
                    {uuid: 3, name: 'Otra identidad'},
                ],
                today: null,
                strings: ['nif', 'name', 'surname'],
                arrays: ['headquartersId'],
                dates: ['birthday', 'autonomousRegisteredAt'],
            }
        },
        computed: {
            entityBirthdayFormatted: {
                get() {
                    if(!this.entity.birthday) return null;
                    return new Date(this.entity.birthday);
                },
                set(newValue) {
                    if(!newValue || newValue === "") {
                        this.entity.birthday = null;
                        return;
                    }
                    this.entity.birthday = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            },
            entityAutonomousRegisteredAtFormatted: {
                get() {
                    if(!this.entity.autonomousRegisteredAt) return null;
                    return new Date(this.entity.autonomousRegisteredAt)
                },
                set(newValue) {
                    if(!newValue || newValue === "") {
                        this.entity.autonomousRegisteredAt = null;
                        return;
                    }
                    this.entity.autonomousRegisteredAt = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            }
        },
        mounted() {
            this.entity = Object.assign({}, this.entity, this.partner);

            this.entity.autonomousRegisteredAt = this.entity.autonomousRegisteredAt ? moment(this.entity.autonomousRegisteredAt).format('YYYY-MM-DD'): null;
            this.entity.birthday = this.entity.birthday ? moment(this.entity.birthday).format('YYYY-MM-DD'): null;

            this.today = new Date();
        },
        methods: {
            changeBirthday(value) {
                this.entityBirthdayFormatted = value;
            },
            changeAutonomousRegistered(value) {
                this.entityAutonomousRegisteredAtFormatted = value;
            },
            store() {
                this.$_loadingMixin_showLoading();
                const self = this;
                try {
                    this.entity.memberId = this.entity.uuid;
                    this.entity.isEdit = true;
                    request(this.entity_url, 'post', 200, this.entity).then(x => {
                        x.memberId = x.uuid;
                        self.setPartner(x);
                        self.$_loadingMixin_hideLoading();
                    });

                } catch (error) {
                    console.log(error);
                }
            },
            validate() {
                if (this.strings.filter(string => !this.entity[string]).length > 0) {
                    return false;
                // } else if (this.dates.filter(value => this.entity[value] == null).length > 0) {
                //     return false;
                } else if (this.arrays.filter(array => this.entity[array].length == 0).length > 0) {
                    return false;
                } else if (this.errors.items.length > 0) {
                    return false;
                } else {
                    return true;
                }
            },
            setPartner(entity) {
                this.$emit('sendPartner', entity);
            }
        }
    }
</script>
